import { Typography, Box } from '@mui/material';
import { ReactNode } from 'react';
import { myVJBlue300, myVJWhite } from '../constants/brandingColors';
import { useAppConfigState } from '../context/AppContext/AppContext';

interface PageHeaderProps {
    title?: string;
    icon?: ReactNode;
    children?: ReactNode;
}

function PageHeader({ title, icon, children }: PageHeaderProps) {
    const { headerTitleInfo } = useAppConfigState();

    // Use provided title or fall back to context pageTitle
    const displayTitle = title || headerTitleInfo?.titleId;

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            padding: '0px !important',
            backgroundColor: myVJWhite,
            marginBottom: '20px',
        }}>
            {/* Icon */}
            {icon && (
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: myVJBlue300,
                    borderRadius: '10%',
                    width: 40,
                    height: 40,
                    padding: '10px',
                    justifyContent: 'center',
                    backgroundImage: 'linear-gradient(135deg, #E2EEFF 0%, #F4F9FF 48.79%)'
                }}>
                    {icon}
                </Box>
            )}

            {/* Page Title */}
            <Typography variant="h4" component="h1" sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: 'text.primary',
                lineHeight: '27px',
            }}>
                {displayTitle}
            </Typography>

            {/* Additional content (like action buttons) */}
            {children && (
                <Box sx={{ marginLeft: 'auto' }}>
                    {children}
                </Box>
            )}
        </Box>
    );
}

PageHeader.displayName = 'PageHeader';

export default PageHeader;